"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Scenery = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M13.909616,8.21326883 L20.909616,18.2132688 C21.1579285,18.6062317 20.8589935,19 20.5,19 L2.5,19 C2.09313326,19 1.84861755,18.5448914 2.09313326,18.2093809 L7.09313326,11.2093809 C7.2989502,10.9307404 7.73075867,10.9307404 7.91602515,11.2226499 L9.5,13.5986122 L13.0839749,8.2226499 C13.3457642,7.86965942 13.7512587,7.98704418 13.909616,8.21326883 Z M13.5100701,9.38628268 L9.5,15.4013878 L7.48580852,12.3801006 L3.47159466,18 L19.5396722,18 L13.5100701,9.38628268 Z M7.5,5 C8.32842712,5 9,5.67157288 9,6.5 C9,7.32842712 8.32842712,8 7.5,8 C6.67157288,8 6,7.32842712 6,6.5 C6,5.67157288 6.67157288,5 7.5,5 Z" })));
};
Scenery.displayName = 'Scenery';
exports.default = Scenery;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Scenery.js.map